import React, { useEffect, useState } from "react";
import { Row, Col, Select } from "antd";
import { Bar, Column, Line, Pie } from "@ant-design/plots";
import useHttp from "../../../hooks/use-http";
const { Option } = Select;

const ProcurementAnalytics = () => {
  const [showLabels, setShowLabels] = useState(false);
  const [financialYears, setFinancialYears] = useState([]);
  const [months, setMonths] = useState([]);
  const [selectedYearId, setSelectedYearId] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [states, setStates] = useState([]);
  const [villages, setVillages] = useState([]);
  const [regions, setRegions] = useState([]);
  const [crops, setCrops] = useState([]);
  const [executives, setExecutives] = useState([]);
  const [fieldExecutiveId, setFieldExecutiveId] = useState("All");
  const [regionId, setRegionId] = useState("All");
  const [cropId, setCropId] = useState("All");
  const [stateName, setStateName] = useState("All");
  const [villageName, setVillageName] = useState("All");
  const [data, setData] = useState([]);
  const [harvestByCrop, setHarvestByCrop] = useState([]);
  const [harvestByExecutive, setHarvestByExecutive] = useState([]);
  const [harvestByRegion, setHarvestByRegion] = useState([]);
  const [harvestByVillage, setHarvestByVillage] = useState([]);
  const [totalProcurementAmount, setTotalProcurementAmount] = useState(0);
  const [top10Procurement, setTop10Procurement] = useState([]);
  const [productWiseGoodIssue, setProductWiseGoodIssue] = useState([]);

  const { sendRequest: getYearMonth } = useHttp();

  const getYearMonthData = () => {
    getYearMonth(
      {
        url: `/api/financialYearMonthForAnalytics/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        // console.log(data);

        setFinancialYears(data?.financialYears);
      }
    );
  };

  useEffect(() => {
    getYearMonthData();
  }, [getYearMonth]);

  const handleYearChange = (yearId) => {
    setSelectedYearId(yearId);
    const selectedYear = financialYears.find((fy) => fy.id === yearId);
    setMonths(selectedYear?.months || []);
    setSelectedMonth("All");

    if (selectedYear) {
      setStartDate(formatDateString(selectedYear.startDate));
      setEndDate(formatDateString(selectedYear.endDate));
    }
  };

  const handleMonthChange = (monthValue) => {
    setSelectedMonth(monthValue);

    const selectedYear = financialYears.find((fy) => fy.id === selectedYearId);

    if (monthValue === "All") {
      if (selectedYear) {
        setStartDate(formatDateString(selectedYear.startDate));
        setEndDate(formatDateString(selectedYear.endDate));
      }
    } else {
      const monthObj = selectedYear?.months.find(
        (m) => m.month === parseInt(monthValue)
      );
      if (monthObj) {
        const firstDay = `01/${padZero(monthObj.month)}/${monthObj.year}`;
        const lastDay = getLastDayOfMonth(monthObj.year, monthObj.month);
        setStartDate(firstDay);
        setEndDate(lastDay);
      }
    }
  };

  const padZero = (num) => String(num).padStart(2, "0");

  const formatDateString = (dateStr) => {
    return dateStr;
  };

  const getLastDayOfMonth = (year, month) => {
    const lastDate = new Date(year, month, 0);
    return `${padZero(lastDate.getDate())}/${padZero(month)}/${year}`;
  };

  const { sendRequest: getAnalyticsFilters } = useHttp();

  const getAnalyticsFiltersData = () => {
    var urlfilter = "";

    if (fieldExecutiveId && fieldExecutiveId !== "All") {
      urlfilter += `&fieldExecutiveId=${fieldExecutiveId}`;
    }

    if (regionId && regionId !== "All") {
      urlfilter += `&regionId=${regionId}`;
    }

    if (cropId && cropId !== "All") {
      urlfilter += `&cropId=${cropId}`;
    }

    if (stateName && stateName !== "All") {
      urlfilter += `&stateName=${encodeURIComponent(stateName)}`;
    }

    if (villageName && villageName !== "All") {
      urlfilter += `&villageName=${encodeURIComponent(villageName)}`;
    }
    const url = `/api/analyticsFilters/?loginEmpId=${localStorage.getItem(
      "id"
    )}&orgId=${parseInt(localStorage.getItem("orgId").trim())}${urlfilter}`;

    getAnalyticsFilters(
      {
        url: url,
      },
      (data) => {
        //      console.log(data);
        setStates(data.states || []);
        setVillages(data.villages || []);
        setRegions(data.regions || []);
        setCrops(data.crops || []);
        setExecutives(data.executives || []);
      }
    );
  };

  useEffect(() => {
    getAnalyticsFiltersData();
  }, [
    getAnalyticsFilters,
    cropId,
    fieldExecutiveId,
    villageName,
    stateName,
    regionId,
  ]);

  const { sendRequest: getData } = useHttp();

  const fillData = () => {
    var urlfilter = "";

    urlfilter = urlfilter + `&fromDate=${startDate}`;

    urlfilter = urlfilter + `&toDate=${endDate}`;

    if (fieldExecutiveId && fieldExecutiveId !== "All") {
      urlfilter += `&fieldExecutiveId=${fieldExecutiveId}`;
    }

    if (regionId && regionId !== "All") {
      urlfilter += `&regionId=${regionId}`;
    }

    if (cropId && cropId !== "All") {
      urlfilter += `&cropId=${cropId}`;
    }

    if (stateName && stateName !== "All") {
      urlfilter += `&stateName=${encodeURIComponent(stateName)}`;
    }

    if (villageName && villageName !== "All") {
      urlfilter += `&villageName=${encodeURIComponent(villageName)}`;
    }

    var url = `/api/contractFarmerValuesForAnalytics/?loginEmpId=${localStorage.getItem(
      "id"
    )}&orgId=${parseInt(localStorage.getItem("orgId"))} ${urlfilter} `;

    getData(
      {
        url: url,
      },
      (res) => {
        // console.log(res);
        setData(res);
      }
    );
  };

  const { sendRequest: getChartData } = useHttp();
  const { sendRequest: getGoodsIssue } = useHttp();

  const fillCharts = () => {
    var urlfilter = "";

    urlfilter = urlfilter + `&fromDate=${startDate}`;

    urlfilter = urlfilter + `&toDate=${endDate}`;

    if (fieldExecutiveId && fieldExecutiveId !== "All") {
      urlfilter += `&fieldExecutiveId=${fieldExecutiveId}`;
    }

    if (regionId && regionId !== "All") {
      urlfilter += `&regionId=${regionId}`;
    }

    if (cropId && cropId !== "All") {
      urlfilter += `&cropId=${cropId}`;
    }

    if (stateName && stateName !== "All") {
      urlfilter += `&stateName=${encodeURIComponent(stateName)}`;
    }

    if (villageName && villageName !== "All") {
      urlfilter += `&villageName=${encodeURIComponent(villageName)}`;
    }

    var url = `/api/contractFarmerAnalyticsProcurement/?loginEmpId=${localStorage.getItem(
      "id"
    )}&orgId=${parseInt(localStorage.getItem("orgId"))} ${urlfilter} `;

    var url2 = `/api/contractFarmerAnalyticsGoodsIssue/?loginEmpId=${localStorage.getItem(
      "id"
    )}&orgId=${parseInt(localStorage.getItem("orgId"))} ${urlfilter} `;

    getChartData(
      {
        url: url,
      },
      (res) => {
        //  console.log("chart Data", res);
        setTotalProcurementAmount(res?.totalProcurementAmount);
        setHarvestByCrop(res?.harvestByCrop);
        setHarvestByExecutive(res?.harvestByExecutive);
        setHarvestByRegion(res?.harvestByRegion);
        setHarvestByVillage(res?.harvestByVillage);
        setTop10Procurement(res?.procurementByArea);
      }
    );

    getGoodsIssue(
      {
        url: url2,
      },
      (res) => {
        console.log("contractFarmerAnalyticsGoodsIssue Data", res);
        setProductWiseGoodIssue(res.productWiseGoodIssue);
      }
    );
  };
  useEffect(() => {
    fillData();
    fillCharts();
  }, [
    selectedYearId,
    startDate,
    endDate,
    cropId,
    fieldExecutiveId,
    villageName,
    stateName,
    regionId,
    selectedMonth,
  ]);

  const procurementConfig = {
    data: totalProcurementAmount,
    xField: "monthName",
    yField: "totalAmount",
    point: {
      shapeField: "square",
      sizeField: 4,
    },
    interaction: {
      tooltip: {
        marker: false,
      },
    },
    style: {
      lineWidth: 2,
    },
    height: 140,
    xAxis: {
      title: {
        text: "Month Name",
        style: {
          fontSize: 12,
          fontWeight: "bold",
        },
      },
    },
    yAxis: {
      title: {
        text: "Total Amount",
        style: {
          fontSize: 12,
          fontWeight: "bold",
        },
      },
    },
  };

  const executiveWiseConfig = () => ({
    data: harvestByExecutive,
    xField: "totalQty",
    yField: "executiveName",
    legend: true,
    color: "#82ca9d",
    height: 380,
    xAxis: {
      title: {
        text: "Total Quantity",
        style: {
          fontSize: 12,
          fontWeight: "bold",
        },
      },
    },
    yAxis: {
      title: {
        text: "Executive Name",
        style: {
          fontSize: 12,
          fontWeight: "bold",
        },
      },
    },
  });

  const top10ProcurementConfig = () => ({
    data: top10Procurement,
    xField: "totalQty",
    yField: "farmerName",
    legend: true,
    color: "#82ca9d",
    height: 380,
    xAxis: {
      title: {
        text: "Total Quantity",
        style: {
          fontSize: 12,
          fontWeight: "bold",
        },
      },
    },
    yAxis: {
      title: {
        text: "Farmer Name",
        style: {
          fontSize: 12,
          fontWeight: "bold",
        },
      },
    },
  });

  const regionwiseConfig = {
    data: harvestByRegion,
    xField: "regionName",
    yField: "totalQty",
    colorField: "regionName",
    group: true,
    style: {
      inset: 5,
    },
    height: 140,
    xAxis: {
      title: {
        text: "Region Name",
        style: {
          fontSize: 12,
          fontWeight: "bold",
        },
      },
    },
    yAxis: {
      title: {
        text: "Total Quantity",
        style: {
          fontSize: 12,
          fontWeight: "bold",
        },
      },
    },
  };

  const cropWiseConfig = {
    data: harvestByCrop,
    angleField: "totalQty",
    colorField: "cropName",
    innerRadius: 0.6,
    innerRadius: 0.6,
    label: showLabels
      ? {
          type: "outer",
          content: (datum) => `${datum.cropName}`,
          style: {
            fontSize: 12,
            fontWeight: "bold",
          },
          layout: [{ type: "pie-spider" }],
        }
      : null,
    tooltip: {
      showTitle: false,
      showMarkers: false,
      formatter: (datum) => ({
        name: datum.cropName,
        value: datum.totalQty,
      }),
    },
    interactions: [
      {
        type: "element-active",
      },
    ],
    legend: {
      color: {
        title: false,
        position: "right",
        rowPadding: 5,
      },
    },
    statistic: {
      title: false,
      content: {
        style: {
          fontSize: "10px",
        },
        formatter: () => {
          const total = harvestByCrop?.reduce(
            (sum, item) => sum + item.totalQty,
            0
          );
          return `Total: ${total || 0}`;
        },
      },
    },
    height: showLabels ? 1000 : 140,
  };

  const villagewiseConfig = {
    data: harvestByVillage,
    xField: "villageName",
    yField: "totalQty",
    colorField: "villageName",
    group: true,
    style: {
      inset: 15,
    },
    height: 140,
    xAxis: {
      title: {
        text: "Village Name",
        style: {
          fontSize: 12,
          fontWeight: "bold",
        },
      },
    },
    yAxis: {
      title: {
        text: "Total Quantity",
        style: {
          fontSize: 12,
          fontWeight: "bold",
        },
      },
    },
  };

  const productwiseGoodsConfig = {
    data: productWiseGoodIssue,
    xField: "product",
    yField: "totalAmount",
    colorField: "product",
    group: true,
    style: {
      inset: 15,
    },
    height: 140,
    xAxis: {
      title: {
        text: "Village Name",
        style: {
          fontSize: 12,
          fontWeight: "bold",
        },
      },
    },
    yAxis: {
      title: {
        text: "Total Quantity",
        style: {
          fontSize: 12,
          fontWeight: "bold",
        },
      },
    },
  };

  return (
    <div style={{ padding: 10 }}>
      <h4 style={{ color: "#008000", marginBottom: 10 }}>Contract Farming</h4>

      {/* Filters */}
      <Row gutter={16} style={{ marginBottom: 20 }}>
        <Col>
          <Row>
            <label>Year</label>
          </Row>
          <Row>
            <Select
              defaultValue=""
              style={{ width: 120 }}
              value={selectedYearId}
              onChange={handleYearChange}
            >
              <Option value="">Select</Option>
              {financialYears &&
                financialYears?.map((x) => (
                  <Option key={x.id} user-id={x.id} value={x.id}>
                    {x.year}
                  </Option>
                ))}
            </Select>
          </Row>
        </Col>

        <Col>
          <Row>
            <label>Month</label>
          </Row>
          <Row>
            <Select
              value={selectedMonth}
              onChange={handleMonthChange}
              style={{ width: 160 }}
            >
              <Option value="All">All</Option>
              {months?.map((m) => (
                <Option key={`${m.month}-${m.year}`} value={m.month}>
                  {m.monthName} {m.year}
                </Option>
              ))}
            </Select>
          </Row>
        </Col>
        <Col>
          <Row>
            <label>State</label>
          </Row>
          <Row>
            <Select
              defaultValue="All"
              style={{ width: 120 }}
              onChange={(value) => {
                setStateName(value);
                setRegionId("All");
                setFieldExecutiveId("All");
                setVillageName("All");
                setCropId("All");
              }}
              value={stateName}
            >
              <Option value="All">All</Option>
              {states &&
                states.map((item, index) => (
                  <Option key={index} value={item.state}>
                    {item.state}
                  </Option>
                ))}
            </Select>
          </Row>
        </Col>

        <Col>
          <Row>
            <label>Region</label>
          </Row>
          <Row>
            <Select
              defaultValue="All"
              style={{ width: 120 }}
              onChange={(value) => {
                setRegionId(value);
                setFieldExecutiveId("All");
                setVillageName("All");
                setCropId("All");
              }}
              value={regionId}
            >
              <Option value="All">All</Option>
              {regions &&
                regions.map((item) => (
                  <Option key={item.regionId} value={item.regionId}>
                    {item.regionName}
                  </Option>
                ))}
            </Select>
          </Row>
        </Col>

        <Col>
          <Row>
            <label>Executive</label>
          </Row>
          <Row>
            <Select
              defaultValue="All"
              style={{ width: 120 }}
              onChange={(value) => {
                setFieldExecutiveId(value);
                setVillageName("All");
                setCropId("All");
              }}
              value={fieldExecutiveId}
            >
              <Option value="All">All</Option>
              {executives &&
                executives.map((item) => (
                  <Option
                    key={item.fieldExecutiveId}
                    value={item.fieldExecutiveId}
                  >
                    {item.fieldExecutiveName}
                  </Option>
                ))}
            </Select>
          </Row>
        </Col>

        <Col>
          <Row>
            <label>Village</label>
          </Row>
          <Row>
            <Select
              defaultValue="All"
              style={{ width: 120 }}
              onChange={(value) => {
                setVillageName(value);
                setCropId("All");
              }}
              value={villageName}
            >
              <Option value="All">All</Option>
              {villages &&
                villages.map((item, index) => (
                  <Option key={index} value={item.villageName}>
                    {item.villageName}
                  </Option>
                ))}
            </Select>
          </Row>
        </Col>

        <Col>
          <Row>
            <label>Crop</label>
          </Row>
          <Row>
            <Select
              defaultValue="All"
              style={{ width: 120 }}
              onChange={(value) => setCropId(value)}
              value={cropId}
            >
              <Option value="All">All</Option>
              {crops &&
                crops.map((item) => (
                  <Option key={item.cropMasterId} value={item.cropMasterId}>
                    {item.cropName}
                  </Option>
                ))}
            </Select>
          </Row>
        </Col>
      </Row>

      <div className="row amtqty-div">
        <div className="col-md-5">
          <div className="card border-success">
            <div className="card-header bg-success text-white fw-bold">
              AMOUNT
            </div>
            <div className="card-body">
              <div className="row text-center">
                <div className="col-3">
                  <h6 className="text-success">
                    <b>
                      {parseFloat(data?.totalProcumentAmount || 0).toFixed(2)}
                    </b>
                  </h6>
                  <p>Total Procurement</p>
                </div>
                <div className="col-3">
                  <h6 className="text-success">
                    <b>
                      {parseFloat(data?.totalGoodsIssueAmount || 0).toFixed(2)}
                    </b>
                  </h6>
                  <p>Total Input Sell</p>
                </div>
                <div className="col-3">
                  <h6 className="text-success">
                    <b>{parseFloat(data?.totalExpense || 0).toFixed(2)}</b>
                  </h6>
                  <p>Total Expense</p>
                </div>
                <div className="col-3">
                  <h6 className="text-success">
                    <b>
                      {parseFloat(data?.totalIntransitLossAmount || 0).toFixed(
                        2
                      )}
                    </b>
                  </h6>
                  <p>Total In-transit loss</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-7">
          <div className="card border-primary">
            <div className="card-header bg-primary text-white fw-bold">
              QUANTITY (Kg)
            </div>
            <div className="card-body">
              <div className="row text-center">
                <div className="col-3">
                  <h6 className="text-primary">
                    <b>{parseFloat(data?.totalProcumentQty || 0).toFixed(2)}</b>
                  </h6>
                  <p className="p-bottom">Total Procurement</p>
                </div>
                <div className="col-2">
                  <h6 className="text-primary">
                    <b>
                      {parseFloat(data?.totalIntransitLossQty || 0).toFixed(2)}
                    </b>
                  </h6>
                  <p className="p-bottom">Total In-transit Loss</p>
                </div>
                <div className="col-3">
                  <h6 className="text-primary">
                    <b>
                      {parseFloat(data?.totalCoveredAreaQty || 0).toFixed(2)}
                    </b>
                  </h6>
                  <p className="p-bottom">Area Covered (Ha)</p>
                </div>
                <div className="col-2">
                  <h6 className="text-primary">
                    <b>{parseFloat(data?.totalEstimatedQty || 0).toFixed(2)}</b>
                  </h6>
                  <p className="p-bottom">Estimated Yield</p>
                </div>
                <div className="col-2">
                  <h6 className="text-primary">
                    <b>{parseFloat(data?.yieldPerArea || 0).toFixed(2)}</b>
                  </h6>
                  <p className="p-bottom">Yield / Ha</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row align-items-stretch">
        <div className="col-7">
          <div className="row">
            <div className="col-12">
              <div className="card" title="Procurement Total Amount">
                <div className="card-header bg-info text-white fw-bold">
                  Procurement Total Amount
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="maximize"
                    >
                      <i className="fas fa-expand"></i>
                    </button>
                  </div>
                </div>
                <div className="card-body overflow-auto">
                  {totalProcurementAmount &&
                  totalProcurementAmount?.length > 0 ? (
                    <Line {...procurementConfig} />
                  ) : (
                    <div className="text-center">No data available</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="card" title="Region-wise Harvest Qty">
                <div className="card-header bg-info text-white fw-bold">
                  Region-wise Harvest Quantity
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="maximize"
                    >
                      <i className="fas fa-expand"></i>
                    </button>
                  </div>
                </div>
                <div className="card-body overflow-auto">
                  {harvestByRegion && harvestByRegion?.length > 0 ? (
                    <Column {...regionwiseConfig} />
                  ) : (
                    <div className="text-center">No data available</div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="card" title="Crop-wise Harvest Qty">
                <div className="card-header bg-info text-white fw-bold">
                  Crop-wise Harvest Quantity
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="maximize"
                      onClick={() => setShowLabels((prev) => !prev)}
                    >
                      <i className="fas fa-expand"></i>
                    </button>
                  </div>
                </div>
                <div className="card-body ">
                  {harvestByCrop && harvestByCrop?.length > 0 ? (
                    <Pie {...cropWiseConfig} />
                  ) : (
                    <div className="text-center">No data available</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card " title="Input Product Issue to Farmer Qty">
                <div className="card-header bg-info text-white fw-bold">
                  Input Product Issue to Farmer Quantity
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="maximize"
                    >
                      <i className="fas fa-expand"></i>
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  {" "}
                  {productWiseGoodIssue && productWiseGoodIssue?.length > 0 ? (
                    <Column {...productwiseGoodsConfig} />
                  ) : (
                    <div className="text-center">No data available</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card" title="Village-wise Harvest Qty">
                <div className="card-header bg-info text-white fw-bold">
                  Village-wise Harvest Quantity
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="maximize"
                    >
                      <i className="fas fa-expand"></i>
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  {harvestByVillage && harvestByVillage?.length > 0 ? (
                    <Column {...villagewiseConfig} />
                  ) : (
                    <div className="text-center">No data available</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-5">
          {" "}
          <div className="row">
            <div className="col-12">
              <div className="card " title="Top 10 Procurement by Qty/Ha">
                <div className="card-header bg-info text-white fw-bold">
                  Top 10 Procurement by Quantity/Hectare
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="maximize"
                    >
                      <i className="fas fa-expand"></i>
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  {top10Procurement && top10Procurement?.length > 0 ? (
                    <Bar {...top10ProcurementConfig()} />
                  ) : (
                    <div className="text-center">No data available</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card" title="">
                <div className="card-header bg-info text-white fw-bold">
                  Field Executive wise Harvest Quantity
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="maximize"
                    >
                      <i className="fas fa-expand"></i>
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  {harvestByExecutive && harvestByExecutive?.length > 0 ? (
                    <Bar {...executiveWiseConfig()} />
                  ) : (
                    <div className="text-center">No data available</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcurementAnalytics;
